import { useTabState } from '@bumaga/tabs'

import styles from './_tab.module.scss'

const Tab = ({ children }) => {
  const { isActive, onClick } = useTabState()

  return (
    <button
      className={`${styles.tab} ${isActive ? styles.tabIsActive : ''}`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default Tab
